import { Component, OnInit, OnDestroy, TemplateRef } from '@angular/core';
import { NgcCookieConsentService, NgcStatusChangeEvent, NgcNoCookieLawEvent } from 'ngx-cookieconsent';
import { Subscription }   from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { StatePersistService } from './core/services/state-persist.service';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { VersionCheck } from './core/services/version-check.service';
import { environment } from 'src/environments/environment';
import { SharedService } from './shared/services/shared.service';
import { ConnectivityService } from './shared/services/connectivity.service';
import { AlertService } from './core/services/alert.service';
import { SharedConsts } from './shared/constants';

declare let ga: any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy{
  title = 'source';
  bsModalRef: BsModalRef;
  user: any;
  informessage = '';
  isOffline = false;
  //keep refs to subscriptions to be able to unsubscribe later
  private popupOpenSubscription: Subscription;
  private popupCloseSubscription: Subscription;
  private initializeSubscription: Subscription;
  private statusChangeSubscription: Subscription;
  private revokeChoiceSubscription: Subscription;
  private noCookieLawSubscription: Subscription;

  constructor(private ccService: NgcCookieConsentService,
    private cookieService: CookieService, private statePersistService: StatePersistService,
    public router: Router, private modalService: BsModalService, private sharedService: SharedService,
    private connectivityService: ConnectivityService, private alertService: AlertService,
    private versionCheck: VersionCheck){
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          // Access the global window object safely
          const globalWindow = window as any;
    
          // Check if Google Analytics is loaded and available
          if (typeof globalWindow.ga === 'function') {
            globalWindow.ga('set', 'page', event.urlAfterRedirects);
            globalWindow.ga('send', 'pageview');
          } else {
            console.warn('Google Analytics (ga) is blocked or not initialized yet.');
          }
        }
      });
  }

  
  ngOnInit() {
    const maintenance_mode = environment.maintenanceMode
     this.router.events.subscribe((event) =>{
      try{
        if (event instanceof NavigationStart){
          if (maintenance_mode){
            this.versionCheck.initVersionCheck(environment.versionCheckURL);
          }
          else{
            this.versionCheck.initVersionCheckForComponent(environment.versionCheckURL)
          }
          
       }
       }catch(e){
         console.log(e)
       }
     });
    this.user = this.statePersistService.getLocalStorage('currentUser')
    this.statePersistService.watchHomePageStorage().subscribe(message => {
      this.user = this.statePersistService.getLocalStorage('currentUser')
    })
    this.popupOpenSubscription = this.ccService.popupOpen$.subscribe(
      () => {
        // you can use this.ccService.getConfig() to do stuff...
        this.cookieService.get('IS_COOKIE_ALLOWED');
    
      });

    this.popupCloseSubscription = this.ccService.popupClose$.subscribe(
      () => {
        // you can use this.ccService.getConfig() to do stuff...
    
      });


    this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
      (event: NgcStatusChangeEvent) => {
        const isSecureEnvironment = window.location.protocol === 'https:';
        if (event.status === 'allow') {
          this.cookieService.set('IS_COOKIE_ALLOWED', 'true',undefined ,'/', undefined, isSecureEnvironment,);
          this.ccService.destroy();
        }
        else if (event.status === 'deny'){
          this.cookieService.set('IS_COOKIE_ALLOWED', 'false',undefined ,'/', undefined, isSecureEnvironment,);
          this.ccService.destroy();
        }
        else {
          this.cookieService.delete('IS_COOKIE_ALLOWED');
        }
      });

    this.revokeChoiceSubscription = this.ccService.revokeChoice$.subscribe(
      () => {
        // you can use this.ccService.getConfig() to do stuff...
      
      });

      this.noCookieLawSubscription = this.ccService.noCookieLaw$.subscribe(
        (event: NgcNoCookieLawEvent) => {
          // you can use this.ccService.getConfig() to do stuff...
        });
          let isCookieAllowed = this.cookieService.get('IS_COOKIE_ALLOWED');
          if (isCookieAllowed == 'true' || isCookieAllowed == 'false') {
            this.ccService.destroy();
          }
        
  }


  ClosedStoreInfo(template: TemplateRef<any>){
    this.informessage = localStorage.getItem('closeStorInfoMessage')
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  ngOnDestroy() {
    this.popupOpenSubscription.unsubscribe();
    this.popupCloseSubscription.unsubscribe();
    this.initializeSubscription.unsubscribe();
    this.statusChangeSubscription.unsubscribe();
    this.revokeChoiceSubscription.unsubscribe();
    this.noCookieLawSubscription.unsubscribe();
  }
}
